// Submit a form payload to Formspree. Returns true on success, false if
// VITE_FORMSPREE_ID is not set (so dev still works without a Formspree account).
// Throws on network or 4xx/5xx responses when configured.
//
// `files` is an optional array of File objects (e.g. from <input type="file">).
// When provided, the request is sent as multipart/form-data so attachments
// reach Formspree. Note: file attachments require a paid Formspree plan.
// Optional: pass `turnstileToken` in `data` (key "cf-turnstile-response") and
// Formspree will verify it against the Turnstile secret you've configured
// in your Formspree form's spam-protection settings.
export const submitToFormspree = async (data, files = []) => {
  const id = import.meta.env.VITE_FORMSPREE_ID;
  if (!id) {
    console.warn("VITE_FORMSPREE_ID is not set — skipping notification email.");
    return false;
  }

  const url = `https://formspree.io/f/${id}`;

  let res;
  if (files && files.length > 0) {
    const fd = new FormData();
    for (const [k, v] of Object.entries(data)) {
      fd.append(k, v == null ? "" : String(v));
    }
    for (const f of files) fd.append("attachments", f, f.name);
    // Don't set Content-Type — browser sets the multipart boundary.
    res = await fetch(url, { method: "POST", headers: { Accept: "application/json" }, body: fd });
  } else {
    res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(data),
    });
  }

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.error || `Formspree returned ${res.status}`);
  }
  return true;
};
